import { useState } from 'react';
import { Box, Button } from '@mui/material';
import { styles } from '../assets/styles';
import '../assets/animations.css';

export function CluesPokemon({ randomPokemon, fetchCountCries }) {
  const [showLetterClue, setShowLetterClue] = useState(false);
  const [showGenClue, setShowGenClue] = useState(false);

  const storedFetchCount = localStorage.getItem('fetch_count_cries');
  fetchCountCries = storedFetchCount ? parseInt(storedFetchCount) : 0;

  const triesTextLetter = fetchCountCries === 2 ? 'try' : 'tries';
  const triesTextGen = fetchCountCries === 5 ? 'try' : 'tries';

  return (
    <Box className="clue" sx={styles.clues}>
      <Box sx={{ ...styles.clues, display: 'block' }}>
        <Button
          disableRipple
          className="clue__button"
          disabled={fetchCountCries < 3}
          sx={styles.letterClue}
          onClick={() => setShowLetterClue(!showLetterClue)}
        >
          {showLetterClue ? `Starts with:  ${randomPokemon.name[0]}` : 'Letter Clue'}
        </Button>
        {fetchCountCries < 3 && (
          <span style={styles.clueSpan}>
            {' '}
            In
            {' '}
            {Math.max(0, 3 - fetchCountCries)}
            {' '}
            {triesTextLetter}
          </span>
        )}
      </Box>
      <Box sx={{ ...styles.clues, display: 'block' }}>
        <Button
          disableRipple
          className="clue__button"
          disabled={fetchCountCries < 6}
          sx={styles.genClue}
          onClick={() => setShowGenClue(!showGenClue)}
        >
          {showGenClue ? `Gen: ${randomPokemon.gen}` : 'Gen Clue'}
        </Button>
        {fetchCountCries < 6 && (
          <span style={styles.clueSpan}>
            {' '}
            In
            {' '}
            {Math.max(0, 6 - fetchCountCries)}
            {' '}
            {triesTextGen}
          </span>
        )}
      </Box>
    </Box>
  );
}
